import React, {Component} from 'react';
import {connect} from 'react-redux';
import './SignChecker.scss';
import {Api} from "../../api";
import DragAndDrop from "../../components/DragAndDrop";
import Loader from "../../components/Common/Loader";

class SignChecker extends Component {

    state = {
        progressBarWidth: 0,
        file: null,
        isUploading: false,
        successUpload: false,
        uploadedContainerData: null,
        fileName: '',
        isLoading: false,
        textLoading: null,
    };

    componentWillMount() {

    }

    componentDidMount() {
    }

    onChangInput = (e) => {
        if (e.target.files && e.target.files.length === 1) {
            this.uploadFile(e.target.files[0]);
        }
    };

    handleLoader = (isLoading, textLoading = null) => {
        this.setState({isLoading, textLoading})
    };

    uploadFile = (file) => {
        if (!file.name.endsWith('.asice'))
            return;

        this.handleLoader(true);
        this.setState({uploadedContainerData: null, isUploading: false, successUpload: false, fileName: file.name});
        this.getBase64(file, (result) => {
            const fileData = {
                data: result,
                name: file.name,
            };

            console.log('Final file name: ' + fileData.name);

            const onUploadProgress = (progressEvent) => {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                //Multiply for 0.6 for visibility while checking signature and wating for response
                const progressBarWidth = (percentCompleted * 0.5) * 320 / 100;
                this.setState({progressBarWidth: progressBarWidth});
            };

            Api.post('public/check-asice', fileData, null, onUploadProgress)
                .then((response) => {
                    console.log(response.data);
                    this.setState({
                        isUploading: false,
                        successUpload: true,
                        uploadedContainerData: response.data,
                        fileName: file.name
                    });
                    this.handleLoader(false);
                }).catch((error) => {
                console.log(error);
                console.log(error.response);
                this.handleLoader(false);
                this.setState({uploadedContainerData: null, isUploading: false, successUpload: false, fileName: ''});
            });
        });
    };

    getBase64 = (file, cb) => {
        let reader = new FileReader();
        reader.onload = function () {
            const index = reader.result.indexOf(",");
            if (index !== -1) {
                cb(reader.result.substring(index + 1, reader.result.length));
            } else {
                cb(reader.result)
            }
        };
        reader.onerror = function (error) {
            console.log('ErrorPage: ', error);
        };
        reader.readAsDataURL(file);
    };

    resetPageData = () => {
        const uploadedContainerData = this.state.uploadedContainerData;
        this.setState({
            isUploading: false,
            successUpload: false,
            uploadedContainerData: null,
            fileName: ''
        });
    };

    render() {
        const {isLoading, textLoading, progressBarWidth, isUploading, fileName, uploadedContainerData, successUpload} = this.state;

        console.log('uploadedContainerData: ' + uploadedContainerData);
        console.log('successUpload: ' + successUpload);
        console.log('isUploading: ' + isUploading);
        return (
            <div className='sign-checker-wrapper'>
                {isLoading && <Loader textLoading={textLoading}/>}
                <div className="sign-checker">
                    <header className="header row">
                        <div className="container row">
                            <div className="w-50 row">
                                <div className="row logo-with-text w-100">
                                    <div className="content-logo">
                                        <a href="https://transfersign.com/#/">
                                            <img src="/img/svg/Logo-big.svg" alt="logo" className="logo"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="header-block-left w-50 row">
                                <nav className="navbar w-100">
                                    <ul className=" row w-100">
                                        <li className="nav-list_item">
                                            <a href="#/sign-checker#about">About</a>
                                        </li>
                                        <li className="nav-list_item">
                                            <a href="#/sign-checker#how-it-works">How it works</a>
                                        </li>
                                        <li className="nav-list_item">
                                            <a href="https://transfersign.com/#/">TransferSign</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </header>
                    <section className="content-custom row" id="/sign-checker#about">
                        <div className=" container row">
                            <div className="w-50 content">
                                <div className="content-label row">
                                    <h1>
                                        Sign Checker
                                    </h1>
                                </div>
                                <div className="content-text w-100 row">
                                    <p>
                                        Check your transaction here.<br/> See if signature and transaction are
                                        valid <br/>and browse container
                                        structure
                                        with attachments. Simple. No registration required.
                                    </p>
                                </div>
                            </div>
                            <div className="w-50 content-left">
                                <div className="drag-drop">
                                    <div className="drag-drop_wrapp">
                                        <div className={(isUploading ? 'display-none' : '')}>
                                            <DragAndDrop handleDrop={this.uploadFile}>
                                                <div className="row">
                                                    <div className="upload-icon col-2 offset-5">
                                                        <div className="relative-trick">
                                                            <div className="cloud">
                                                                <img src="/img/svg/upload-vector.svg" alt="uplpad"
                                                                     className="icons"/>
                                                            </div>
                                                            <div className="arrow">
                                                                <img src="/img/svg/arrow-vector.svg" alt="uplpad"
                                                                     className="icons"/>
                                                            </div>
                                                            <div className="line">
                                                                <img src="/img/svg/line-vector.jpg" alt="uplpad"
                                                                     className="icons"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </DragAndDrop>

                                            <div className="row">
                                                <div className="offset-1 col-10 button-menu">
                                                    <div className="drop-text">
                                                        Drag and drop ASICE container here
                                                    </div>
                                                    <div className="or-text">or</div>
                                                    <div className="brows-file-button">
                                                        <div className="brows-file-button">
                                                            <input onChange={this.onChangInput} accept=".asice"
                                                                   type="file"
                                                                   className="file" id="fileElem"/>
                                                            <button className="btn-success">
                                                                <label id="brows-file-label" htmlFor="fileElem">Browse
                                                                    files</label>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/*<div className={"uploading-label " + (isUploading ? '' : 'display-none')}>*/}
                                    {/*Uploading...*/}
                                    {/*</div>*/}
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="footer row" id={'/sign-checker#how-it-works'}>
                        <div className="container" id={'how-it-works'}>
                            <div
                                className={!isUploading && !successUpload ? 'row justify-content-around' : 'd-none'}>
                                <div className="list_item align-items-center">
                                    <div className="item-icon upload-icon">
                                        <div className="relative-trick">
                                            <div className="cloud">
                                                <img src="/img/svg/upload-vector.svg" alt="uplpad"
                                                     className="icons"/>
                                            </div>
                                            <div className="arrow">
                                                <img src="/img/svg/arrow-vector.svg" alt="uplpad" className="icons"/>
                                            </div>
                                            <div className="line">
                                                <img src="/img/svg/line-vector.jpg" alt="uplpad" className="icons"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item-text">
                                        Upload ASICE container
                                    </div>
                                </div>
                                <div className="list_item ">
                                    <div className="item-icon upload-icon">
                                        {/*<a href="#" className="link">*/}
                                        <img src="/img/svg/check-icon.svg" alt="icon" className="icon"/>
                                        {/*</a>*/}
                                    </div>

                                    <div className="item-text">
                                        Check transaction
                                        and signature
                                    </div>

                                </div>

                                <div className="list_item align-items-center">
                                    <div className="item-icon download-icon">
                                        <div className="relative-trick">
                                            <div className="cloud">
                                                <img src="/img/svg/upload-vector.svg" alt="uplpad"
                                                     className="icons"/>
                                            </div>
                                            <div className="arrow">
                                                <img src="/img/svg/arrow-vector.svg" alt="uplpad" className="icons"/>
                                            </div>
                                            <div className="line">
                                                <img src="/img/svg/line-vector.jpg" alt="uplpad" className="icons"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="item-text">
                                        Download transaction documents
                                    </div>
                                </div>
                            </div>
                            <div
                                className={(isUploading || successUpload) ? 'upload-block_inner container' : 'd-none'}>
                                <div className="upload-block_inner-title">
                                    Uploads
                                </div>

                                {/*<div className={isUploading ? 'block-upload-progres row' : 'd-none'}>*/}
                                {/*<div className="progres-icon">*/}
                                {/*<img src="/img/svg/Group-upload.svg" alt="icon" className="icon"/>*/}
                                {/*</div>*/}
                                {/*<div className="block-progressbar row">*/}
                                {/*<div className="block-progressbar-title">*/}
                                {/*{fileName}*/}
                                {/*</div>*/}
                                {/*<div className="progressbar">*/}
                                {/*<div className={'progressbar-progress'} style={{*/}
                                {/*width: progressBarWidth,*/}
                                {/*}}>*/}

                                {/*</div>*/}
                                {/*</div>*/}

                                {/*</div>*/}
                                {/*</div>*/}

                                {uploadedContainerData &&
                                <div className={'block-upload-finish'}>
                                    <div className="block-upload-finish-info row align-items-center">
                                        <div className="progres-icon">
                                            <img src="/img/svg/Group-upload.svg" alt="icon" className="icon"/>
                                        </div>
                                        <div className="block-upload-finish-nameFile row">
                                            Name {fileName}
                                        </div>
                                        {uploadedContainerData && uploadedContainerData.pdfDirectory && uploadedContainerData.pdfDirectory !== '' &&
                                        <div className="block-upload-finish-delete row align-items-center">
                                            <a onClick={this.resetPageData}>
                                                <img src="/img/svg/trash-2.svg" alt="" className="basket"/>
                                            </a>
                                        </div>
                                        }
                                        {uploadedContainerData && uploadedContainerData.pdfDirectory && uploadedContainerData.pdfDirectory !== '' &&
                                        <div className="download-attachment ">
                                            <div className="download-attachment-title">
                                                Download <br/>
                                                attachment
                                            </div>
                                            <div className="download-attachment-icon">
                                                <a target="_blank"
                                                   href={`${process.env.API}/public/pdf?dir-name=${uploadedContainerData.pdfDirectory}`}>
                                                    <img src="/img/svg/Group_small.svg" alt=""
                                                         className="icon"/>
                                                </a>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                    <div className="block-upload-finish-list ">
                                        <ol type="circle" className="custom-counter">
                                            {uploadedContainerData.isContainerValid ?
                                                <li className={'upload-list-item valid-item'}>Container is
                                                    valid</li>
                                                :
                                                <li className="upload-list-item invlid-item">Container is invalid</li>
                                            }
                                            {uploadedContainerData.isSignatureValid ?
                                                <li className={'upload-list-item valid-item'}>Signature is
                                                    valid</li>
                                                :
                                                <li className="upload-list-item invlid-item">Signature is invalid</li>
                                            }
                                            {uploadedContainerData.isTxValid ?
                                                <li className={'upload-list-item valid-item'}>Transaction is
                                                    valid</li>
                                                :
                                                <li className="upload-list-item invlid-item">Transaction is invalid</li>
                                            }
                                        </ol>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>

                    </section>
                    <footer className="footer-bottom">
                        <div className="container row">
                            <span>© 2019 TransferSign</span>
                        </div>

                    </footer>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(SignChecker);


// WEBPACK FOOTER //
// ./src/views/SignChecker/SignChecker.js